import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "setup-domain"
    }}>{`Setup domain`}</h2>
    <p>{`-- `}<a parentName="p" {...{
        "href": "deploy-on-web-domain-registration.md"
      }}>{`Register domain`}</a></p>
    <p>{`-- `}<a parentName="p" {...{
        "href": "deploy-on-web-digitalocean.md"
      }}>{`Setup domain with DigitalOcean DNS`}</a></p>
    <p>{`-- `}<a parentName="p" {...{
        "href": "deploy-on-web-cloudflare.md"
      }}>{`Setup domain with Cloudflare`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      